<script setup lang="ts">
import { computed } from "vue";
import { SentenceTranslationData, TranslationMode } from "@lingvo-news/contracts";
import NewsItemStyle2 from "./news-item-style-2.vue";

const props = defineProps({
  mode: {
    type: Object as () => TranslationMode,
    required: true,
  },
  transliterate: {
    type: Boolean,
    required: true,
  },
  soundEnabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  titleData: {
    type: Object as () => SentenceTranslationData,
    required: true,
  },
  sourceLang: {
    type: String,
    required: false,
    default: "",
  },
  targetLang: {
    type: String,
    required: false,
    default: "",
  },
  imageUrl: {
    type: String,
    required: false,
    default: "",
  },
  date: {
    type: String,
    required: false,
    default: "",
  },
  source: {
    type: String,
    required: false,
    default: "",
  },
  link: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['open', 'audio-auth-required', 'audio-paywall-required']);

// Quick hash function for strings
function quickHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

// Get the original text from titleData for hashing
const titleText = computed(() => {
  if (!props.titleData?.originalWords) return '';
  return props.titleData.originalWords.join(' ');
});

// Determine which style to use based on hash (0-3)
const styleComponent = computed(() => {
  return NewsItemStyle2;
});

const handleOpen = (link: string) => {
  emit('open', link);
};

const handleAudioAuthRequired = () => {
  emit('audio-auth-required');
};

const handleAudioPaywallRequired = () => {
  emit('audio-paywall-required');
};
</script>

<template>
  <component
      :is="styleComponent"
      :sourceLang="sourceLang"
      :targetLang="targetLang"
      :transliterate="transliterate"
      :sound-enabled="soundEnabled"
      :title-data="titleData"
      :image-url="imageUrl"
      :date="date"
      :mode="mode"
      :source="source"
      :link="link"
      @open="handleOpen"
      @audio-auth-required="handleAudioAuthRequired"
      @audio-paywall-required="handleAudioPaywallRequired"
  />
</template>
